export default function TotalDealersIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <ellipse
        cx="14"
        cy="19.25"
        rx="7"
        ry="2.91667"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <ellipse
        cx="14"
        cy="9.33337"
        rx="3.5"
        ry="3.5"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.27591 15.609C5.9393 15.6868 4.71904 15.9381 3.76338 16.3204C3.18327 16.5524 2.66348 16.8475 2.27646 17.2135C1.88785 17.581 1.58337 18.0718 1.58337 18.6666C1.58337 19.2615 1.88785 19.7523 2.27646 20.1198C2.66348 20.4858 3.18327 20.7809 3.76338 21.0129C4.29663 21.2262 4.91226 21.3987 5.58453 21.5231C5.1209 20.981 4.81794 20.3872 4.7104 19.7612C4.57378 19.7166 4.44363 19.6695 4.32046 19.6202C3.84494 19.43 3.51046 19.2223 3.30712 19.03C3.10536 18.8392 3.08337 18.7161 3.08337 18.6666C3.08337 18.6171 3.10536 18.4941 3.30712 18.3033C3.51046 18.111 3.84494 17.9033 4.32046 17.7131C4.59747 17.6023 4.90981 17.5024 5.25164 17.4165C5.70255 16.7361 6.39721 16.1223 7.27591 15.609Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M23.2896 19.7612C23.1821 20.3872 22.8791 20.981 22.4155 21.5231C23.0878 21.3987 23.7034 21.2262 24.2367 21.0129C24.8168 20.7809 25.3365 20.4858 25.7236 20.1198C26.1122 19.7523 26.4167 19.2615 26.4167 18.6666C26.4167 18.0718 26.1122 17.581 25.7236 17.2135C25.3365 16.8475 24.8168 16.5524 24.2367 16.3204C23.281 15.9381 22.0607 15.6868 20.7241 15.609C21.6028 16.1223 22.2975 16.7361 22.7484 17.4165C23.0902 17.5024 23.4026 17.6023 23.6796 17.7131C24.1551 17.9033 24.4896 18.111 24.6929 18.3033C24.8947 18.4941 24.9167 18.6171 24.9167 18.6666C24.9167 18.7161 24.8947 18.8392 24.6929 19.03C24.4896 19.2223 24.1551 19.43 23.6796 19.6202C23.5564 19.6695 23.4263 19.7166 23.2896 19.7612Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.2116 11.9566C18.9822 12.4114 18.6951 12.8321 18.3597 13.209C18.7975 13.4477 19.2996 13.5833 19.8333 13.5833C21.5362 13.5833 22.9167 12.2028 22.9167 10.5C22.9167 8.79708 21.5362 7.41663 19.8333 7.41663C19.7264 7.41663 19.6208 7.42207 19.5167 7.43269C19.6787 7.90303 19.7823 8.40059 19.8187 8.91669C19.8236 8.91665 19.8285 8.91663 19.8333 8.91663C20.7078 8.91663 21.4167 9.62551 21.4167 10.5C21.4167 11.3744 20.7078 12.0833 19.8333 12.0833C19.6127 12.0833 19.4025 12.0381 19.2116 11.9566Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.48334 7.43269C8.37924 7.42207 8.27361 7.41663 8.16671 7.41663C6.46383 7.41663 5.08337 8.79708 5.08337 10.5C5.08337 12.2028 6.46383 13.5833 8.16671 13.5833C8.70044 13.5833 9.20251 13.4477 9.64032 13.209C9.30499 12.8321 9.01781 12.4114 8.78842 11.9566C8.59755 12.0381 8.3874 12.0833 8.16671 12.0833C7.29226 12.0833 6.58337 11.3744 6.58337 10.5C6.58337 9.62551 7.29226 8.91663 8.16671 8.91663C8.17159 8.91663 8.17648 8.91665 8.18135 8.91669C8.21777 8.40059 8.32133 7.90303 8.48334 7.43269Z"
        fill="currentColor"
      />
    </svg>
  );
}
